export default {
  setUser(state, payload) {
    state.token = payload.token;
    state.userName = payload.userName;
  },
  setLtsNotification(state, payload) {
    state.ltsNotification = payload;
  }
};